import React from "react";
import "../../Styles/yellowcalf.css/Invoice_Balance_Report.css";

function Invoice_Balance_Report() {
  return (
    <div
      className="invoice-balance-report-container"
      style={{ paddingTop: "25px" }}
    >
      <div className="invoice-balance-report-header-section">
        <div className="invoice-balance-report-header-box">
          <h3 className="invoice-balance-report-header-title">
            Invoice Balance Report
          </h3>

          <div className="invoice-balance-report-export-section">
            <button className="invoice-balance-report-export-button">
              Export <i className="fa fa-angle-down"></i>
            </button>

            <ul className="invoice-balance-report-export-list">
              <li>
                <a href="#">Save as PDF</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="invoice-balance-report-filter-section">
        <div className="invoice-balance-report-filter-row">
          <div className="invoice-balance-report-filter-item">
            <select id="student_id" className="invoice-balance-report-select">
              <option value="">Select Grade</option>
              <option value="189">ssds - hjh45</option>
              <option value="207">hebu - 78787878</option>
              <option value="211">siva - 34567889</option>
              <option value="186">Kaleem - 456</option>
            </select>
          </div>

          <div className="invoice-balance-report-filter-item">
            <select id="student_id" className="invoice-balance-report-select">
              <option value="">Select Division</option>
              <option value="189">ssds - hjh45</option>
              <option value="207">hebu - 78787878</option>
              <option value="211">siva - 34567889</option>
              <option value="186">Kaleem - 456</option>
            </select>
          </div>

          <div className="invoice-balance-report-filter-item">
            <select id="student_id" className="invoice-balance-report-select">
              <option value="">Select All Students</option>
              <option value="189">ssds - hjh45</option>
              <option value="207">hebu - 78787878</option>
              <option value="211">siva - 34567889</option>
              <option value="186">Kaleem - 456</option>
            </select>
          </div>
          <div className="invoice-balance-report-filter-item">
            <button
              type="submit"
              className="invoice-balance-report-btn invoice-balance-report-btn-search"
            >
              Search
            </button>
            <button
              type="reset"
              className="invoice-balance-report-btn invoice-balance-report-btn-clear"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Invoice_Balance_Report;
